import type { SlideProps } from "@/engine/app/offsite-config";

export function Slide27Botschaft2(_: SlideProps) {
  return (
    <div className="deck-root dark slide-manifesto" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1">Botschaft 02</div>
        <h1 className="deck-title rise rise-2">
          Die Technik <br />
          <span className="accent">unterstützt euch</span>
        </h1>
      </header>

      <div className="deck-big">
        <div className="big-statement rise rise-4">
          Jeder Prozess, jede KI-Anwendung hat{" "}
          <span className="accent">ein Sicherheitsnetz.</span>
        </div>
      </div>
    </div>
  );
}
